import TendencyDownIcon from '@/shared/assets/arrow-half-down.svg?react';
import TendencyUpIcon from '@/shared/assets/arrow-half-up.svg?react';
import TendencyNeutralIcon from '@/shared/assets/arrow-right.svg?react';
import { Gradients } from '@/shared/components/theme/gradient';
import RoundedIcon from '@/shared/components/ui/rounded-icon';
import { cn } from '@/shared/utils/cn';

type TendencyType = 'up' | 'down' | 'neutral';
type TendencySize = 'small' | 'default';

export type { TendencyType };

type TendencyIndicatorProps = {
  tendency: TendencyType;
  size?: TendencySize;
};

const TendencyIndicator = ({
  tendency,
  className,
  size = 'default',
}: TendencyIndicatorProps & { className?: string }) => {
  const getIconStyles = () => {
    switch (tendency) {
      case 'up':
        return {
          icon: (
            <TendencyUpIcon
              className={cn('size-5', size === 'small' && 'size-3')}
            />
          ),
          bgColor: Gradients.turquoiseBlueGreenGradient,
        };
      case 'down':
        return {
          icon: (
            <TendencyDownIcon
              className={cn('size-5', size === 'small' && 'size-3')}
            />
          ),
          bgColor: Gradients.pinkRedGradient,
        };
      case 'neutral':
        return {
          icon: (
            <TendencyNeutralIcon
              className={cn('size-5', size === 'small' && 'size-3')}
            />
          ),
          bgColor: Gradients.orangeYellowGradient,
        };
    }
  };

  const { icon, bgColor } = getIconStyles();

  return (
    <RoundedIcon
      icon={icon}
      bgColor={bgColor}
      className={cn(size === 'small' && '!size-5', className)}
    />
  );
};

export const getTendency = (
  forecastValue: number,
  previousPeriodValue: number | null,
): TendencyType => {
  if (!previousPeriodValue) return 'neutral';

  const percentageChange =
    ((forecastValue - previousPeriodValue) / Math.abs(previousPeriodValue)) *
    100;

  if (percentageChange > 1) return 'up';
  if (percentageChange < -1) return 'down';
  return 'neutral';
};

export const getTendencyFromPercentageChange = (
  percentageChange: number,
): TendencyType => {
  if (percentageChange > 1) return 'up';
  if (percentageChange < -1) return 'down';
  return 'neutral';
};

export default TendencyIndicator;
